export const checkScheduleIsActive = (scheduleDate?: string, expirationDate?: string) => {
	if (!scheduleDate) return false;

	const now = new Date().toISOString();
	const scheduleStartIsPast = now > scheduleDate;

	if (expirationDate && scheduleStartIsPast) {
		return expirationDate > now; // Announcement start time is past, but expiration date is in the future
	}

	return scheduleStartIsPast; // Start time has triggered
};

export default checkScheduleIsActive;
